import controller from './autocomplete-wizard-search.controller'
import template from './autocomplete-wizard-search.html'
import './autocomplete-wizard-search.scss'

const AutocompleteWizardSearchComponent = {
	bindings: {
		carrierList: '<',
		planList: '<',
		language: '<',
		onSelect: '&'
	},
	controller,
	template,
};

export default AutocompleteWizardSearchComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/autocomplete-wizard-search/autocomplete-wizard-search.component.js